// @flow

import * as React from 'react';

import { Select } from '@gandi/ui-select';

import { withRouter } from 'src/helpers/withRouter';
import { useAppSelector } from 'src/hooks/useAppSelector';

import type { Option } from '../../../modules/app/selectors/locale';

import { selectShopOrgaList } from './modules/selectors';

type Props = {
  onChange: (option: Option) => void,
  disabled?: boolean,
  loading?: boolean,
  value: string,
  name: string,
  className?: string,
  readOnly?: boolean,
};

function OrgaSelect({
  onChange,
  disabled,
  loading,
  value,
  name,
  className,
  readOnly,
}: Props): React.MixedElement {
  const list = useAppSelector(selectShopOrgaList);

  const options = list.map(orga => ({
    label: orga.name,
    value: orga.id,
  }));

  const selectedOption = options.find(opt => opt.value === value);

  const isDisabled = disabled || loading;

  return (
    <Select
      name={name}
      options={options}
      value={selectedOption}
      onChange={onChange}
      isLoading={loading}
      isDisabled={isDisabled}
      isReadonly={!isDisabled && (options.length <= 1 || readOnly)}
      className={className}
    />
  );
}

export default (withRouter(OrgaSelect): React.ComponentType<Props>);
